import object from '@mailobj-browser/front/js/utils/object.js'

export const block = 'ea_generics__xfiles'

export const elements = object(null, {
  xfiles: block,
  xfiles_attach: `${block}_attach`,
  xfiles_attach_has_file_attached: `${block}_attach_has_file_attached`,
  xfiles_attach_container: `${block}_attach_container`,
  xfiles_attach_draw_canvas: `${block}_attach_draw_canvas`,
  xfiles_attach_draw_canvas_drawn: `${block}_attach_draw_canvas_drawn"`,
  xfiles_attach_draw_colors_stored: `${block}_attach_draw_colors_stored`,
  xfiles_attach_draw_tool: `${block}_attach_draw_tool`,
  xfiles_attach_draw_tools: `${block}_attach_draw_tools`,
  xfiles_attach_item_selectable: `${block}_attach_item_selectable`,
  xfiles_item: `${block}_item`,
  xfiles_list: `${block}_list`,
  xfiles_uploads: `${block}_uploads`,
  xfiles_path: `${block}_path`,
  xfiles_size: `${block}_size`,
})

export const modifiers = object(null, {
  xfiles_attach_draw_tool: object(null, {
    selected: `${elements.xfiles_attach_draw_tool}-selected`,
  }),
})